import { TrendingUp, TrendingDown, Award } from 'lucide-react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const priceData = [
  { date: '01/06', price: 2650 },
  { date: '01/13', price: 2680 },
  { date: '01/20', price: 2720 },
  { date: '01/27', price: 2690 },
  { date: '02/03', price: 2750 },
  { date: '02/10', price: 2800 },
  { date: '02/17', price: 2780 },
];

export default function DiscoverPage() {
  return (
    <div className="min-h-full bg-slate-50">
      {/* 页面头部 */}
      <div className="bg-white px-4 py-3 border-b border-slate-200">
        <h1 className="text-xl font-bold text-slate-800">发现</h1>
      </div>

      {/* 内容区域 */}
      <div className="p-4">
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-4 mb-4">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-bold text-slate-800">废钢价格指数</h2>
          <div className="text-sm text-blue-500 font-medium">近7周走势</div>
        </div>
        
        <div className="h-64 mb-4">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={priceData} margin={{ top: 5, right: 5, bottom: 5, left: 0 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
              <XAxis dataKey="date" tick={{ fontSize: 10 }} />
              <YAxis tick={{ fontSize: 10 }} domain={['dataMin - 50', 'dataMax + 50']} />
              <Tooltip 
                contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
                formatter={(value) => [`${value} 元/吨`, '价格']}
              />
              <Line 
                type="monotone" 
                dataKey="price" 
                stroke="#3b82f6" 
                strokeWidth={2}
                dot={{ r: 4 }}
                activeDot={{ r: 6, strokeWidth: 0 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
        
        <div className="flex justify-between items-center">
          <div>
            <div className="text-xs text-slate-500">当前指数</div>
            <div className="text-2xl font-bold text-slate-800">2,780 <span className="text-sm font-normal text-slate-500">元/吨</span></div>
          </div>
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-1">
              <TrendingUp size={16} className="text-green-500" />
              <span className="text-sm font-medium text-green-500">+30</span>
            </div>
            <div className="flex items-center gap-1">
              <TrendingDown size={16} className="text-red-500" />
              <span className="text-sm font-medium text-red-500">2.1%</span>
            </div>
          </div>
        </div>
      </div>
      
      <div className="bg-amber-50 border border-amber-200 rounded-xl px-4 py-3">
        <div className="flex items-start gap-2">
          <Award size={16} className="text-amber-500 shrink-0 mt-0.5" />
          <div className="text-xs text-amber-700 leading-relaxed">
            价格指数仅供参考，实际交易价格以各基地实时挂牌价为准。数据更新周期：每周一。
          </div>
        </div>
      </div>
      </div>
    </div>
  );
}
